import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f4k7amd5: FaireBrandEntity = {
  token: "b_f4k7amd5",
  type: "brand",
  name: "Bonnie Skincare",
  avatarUrl:
    "https://cdn.faire.com/fastly/eacb3c21079e8e4fece82191da4b0ecd82240f29d0404d61a9b5e0ca083a1afa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/924c3a8e3bf6b42681202fc44fb168726f1696d2e9fc2f06db1d38aa98ea8508.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eacb3c21079e8e4fece82191da4b0ecd82240f29d0404d61a9b5e0ca083a1afa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/924c3a8e3bf6b42681202fc44fb168726f1696d2e9fc2f06db1d38aa98ea8508.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 26,
  isInsider: true,
  description:
    "In February of 2010, Chicago fine artist Sarah deHebreard turned her focus from painting pictures to making lip balm, and Bonnie was born. Her high-performance products harness the goodness that nature provides in sophisticated and creative ways, making use of natural compounds in complex formulations. Sarah is constantly developing new formulas with a focus on sensitive skin, and searching for new and interesting ways to combine nature and science. As a self-described micro-manager with an eye for detail, Sarah handles every aspect of Bonnie on her own; including graphic and web design, product development, marketing, production, and packaging. \n\nFeatured in Midwest Living Magazine (March/April 2022).",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:50.485Z",
    importedBy: "entity-db-cli",
  },
};
